import React, { useMemo, useState, useCallback } from 'react';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import { string, arrayOf, shape } from 'prop-types';
import cn from 'classnames';
import { Icon } from '@vpp-frontend-components/icon';
import { backgroundColor, ANDES, colornames, sizenames, familynames, trackEvent, onIframeModalResize, constants, stringIncludes, PriceFontSize, DiscountFontSize, margins } from '@vpp-frontend-components/common';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Iframe } from '@vpp-frontend-components/iframe';
import { MediaAction } from '@vpp-frontend-components/media';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { ActionModal } from '@vpp-frontend-components/action-modal';
import { TOOLTIP_CONSTANTS, useTooltipWithFrequencyStatus, Tooltip } from '@vpp-frontend-components/tooltip';
import { MoneyAmount, MoneyAmountDiscount } from '@andes/money-amount';
import { VisuallyHidden } from '@andes/common';
import AndesTooltip from '@andes/tooltip';
import { Button } from '@andes/button';
import { PaymentIcon } from '@vpp-frontend-components/payment-icon';
import { Row } from '@vpp-frontend-components/grid';
import { Label } from '@vpp-frontend-components/promotions';
import CarouselFree, { CarouselFreeSlide } from '@andes/carousel-free';
import { TagLimited, TagElement } from '@vpp-frontend-components/tag-limited';
import Card$1, { Card } from '@andes/card';
import { useViewCounter } from '@vpp-frontend-components/hooks';
const _excluded$1 = ["price"];
const jsonToProps = _ref => {
  let {
      price
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  // TODO remove esto cuando backend mergee price
  if (!price) {
    return null;
  }
  const {
    currency_symbol: currencySymbol,
    original_value: originalValue,
    value,
    label,
    billing,
    bulk_sales_unit: bulkSalesUnit,
    bulk_sales: bulkSales,
    price_reference: priceReference
  } = price;
  const {
    subtitles,
    upper_label: upperLabel,
    discount_label: discountLabel,
    discount_label_secondary: discountLabelSecondary,
    discount_label_subtitle: discountLabelSubtitle
  } = rest;
  if (bulkSales) {
    const {
      original_value: originalBulkSalesValue,
      value: bulkSalesValue,
      color,
      text,
      accessibility_text: accessibilityText
    } = bulkSales;
    return _objectSpread(_objectSpread({}, rest), {}, {
      currencySymbol,
      originalValue: originalBulkSalesValue !== null && originalBulkSalesValue !== void 0 ? originalBulkSalesValue : originalValue,
      value: bulkSalesValue,
      label,
      billing,
      upperLabel,
      discountLabel,
      discountLabelSecondary,
      bulkSalesUnit: {
        hasUnits: true,
        color,
        text,
        accessibilityText
      },
      discountLabelSubtitle,
      priceReference,
      subtitles
    });
  }
  return _objectSpread({
    currencySymbol,
    originalValue,
    value,
    label,
    billing,
    upperLabel,
    discountLabel,
    discountLabelSecondary,
    bulkSalesUnit,
    discountLabelSubtitle,
    subtitles,
    priceReference
  }, rest);
};
const mapDecimalSymbol = {
  ',': 'comma',
  '.': 'dot'
};
const getFormattedIntFraction = (price, separator) => {
  const rawFraction = Math.floor(price).toString();
  return rawFraction.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, n => `${n}${separator}`);
};
const getFormattedDecimalFraction = function (price) {
  let forceCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const fixedStr = price.toFixed(2);
  const decimalPart = fixedStr.split('.')[1];
  if (decimalPart !== '00' || forceCents) {
    return decimalPart;
  }
  return '';
};
var _Icon$6;
const namespace$c = 'ui-pdp-price';
const LOYALTY_TOOLTIP_ID$1 = 'loyalty_discount_tooltip';
const BUY_LOYALTY_TOOLTIP_ID$3 = 'buy_loyalty_level_tooltip';
const CURRENCY_TOOLTIP_ID$5 = 'currency_tooltip';
const LoyaltyTooltip = _ref => {
  let {
    id,
    title,
    icon
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "loyalty-discount-tooltip",
    className: `${namespace$c}__tooltip-${id}`
  }, void 0, icon && /*#__PURE__*/React.createElement(Icon, icon), /*#__PURE__*/React.createElement(StyledLabel, _extends({
    as: "span",
    className: `${id}__content`
  }, title)));
};
const ForeignCurrencyTooltipInfo = _ref2 => {
  let {
    id,
    title,
    subtitles,
    action = null
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "currency-tooltip",
    className: `${namespace$c}__tooltip-${id}`
  }, void 0, /*#__PURE__*/React.createElement(StyledLabel, _extends({
    className: `${namespace$c}__tooltip-${id}__title`,
    as: "p"
  }, title)), subtitles.map(subtitle => /*#__PURE__*/React.createElement(StyledLabel, _extends({
    className: `${namespace$c}__tooltip-${id}__subtitle`,
    as: "p"
  }, subtitle, {
    text: componentEnhance.jsx(subtitle.text)
  }))), action && /*#__PURE__*/React.createElement(MediaAction, _extends({
    className: `${namespace$c}__tooltip-${id}__action`
  }, action, {
    htmlTarget: action.html_target
  })));
};
const ActionComponent = _ref3 => {
  let {
    text
  } = _ref3;
  return /*#__PURE__*/_jsx("span", {}, void 0, ' ', text, " ", _Icon$6 || (_Icon$6 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  })), ' ');
};
const BuyLoyaltyTooltip = _ref4 => {
  let {
    id,
    title,
    icon,
    action,
    closeModalLabel
  } = _ref4;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "buy-loyalty-tooltip",
    className: `${namespace$c}__tooltip-${id}`
  }, void 0, icon && /*#__PURE__*/React.createElement(Icon, icon), /*#__PURE__*/_jsx("div", {
    className: `${id}__content`
  }, void 0, /*#__PURE__*/React.createElement(StyledLabel, _extends({
    as: "span"
  }, title)), /*#__PURE__*/_jsx(ActionModal, {
    modalClassName: `${namespace$c}__buy-loyalty-modal`,
    url: action.target,
    componentAsLabel: /*#__PURE__*/_jsx(ActionComponent, {
      text: action.label.text
    }),
    autoHeight: false,
    closeModalLabel: closeModalLabel
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    title: null,
    src: action.target,
    scrolling: "no",
    height: 525
  }))));
};
const TOOLTIP_CONTENT_BY_ID = {
  [LOYALTY_TOOLTIP_ID$1]: LoyaltyTooltip,
  [BUY_LOYALTY_TOOLTIP_ID$3]: BuyLoyaltyTooltip,
  [CURRENCY_TOOLTIP_ID$5]: ForeignCurrencyTooltipInfo
};
const getTooltipContent = tooltip => {
  if (tooltip) {
    const TooltipComponent = TOOLTIP_CONTENT_BY_ID[tooltip.id];
    return TooltipComponent ? /*#__PURE__*/React.createElement(TooltipComponent, tooltip) : null;
  }
  return null;
};
const {
  SIDE,
  TRIGGER
} = TOOLTIP_CONSTANTS;
const CURRENCY_TOOLTIP_ID$4 = 'currency_tooltip';
const getTooltipProps = _ref => {
  let {
    tooltip,
    namespace,
    showTooltip,
    setTooltipVisibility,
    openCurrencyTooltip,
    setOpenCurrencyTooltip,
    useHoverTrigger,
    isCurrencyTooltip
  } = _ref;
  let openTooltipProps = {
    open: isCurrencyTooltip ? openCurrencyTooltip : showTooltip
  };
  if (useHoverTrigger) {
    openTooltipProps = {};
  }
  return _objectSpread({
    id: tooltip === null || tooltip === void 0 ? void 0 : tooltip.id,
    className: cn(`${namespace}__tooltip`, {
      [backgroundColor(tooltip)]: tooltip
    }),
    content: getTooltipContent(tooltip),
    side: SIDE.LEFT,
    trigger: useHoverTrigger ? TRIGGER.HOVER : TRIGGER.NO_TRIGGER,
    offsetX: -16,
    storable: tooltip === null || tooltip === void 0 ? void 0 : tooltip.storable,
    mouseLeaveDelay: 0.3,
    closable: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.closeable) && !useHoverTrigger,
    onClose: () => {
      if (isCurrencyTooltip) {
        localStorage.setItem(CURRENCY_TOOLTIP_ID$4, Math.floor(Date.now() / 1000));
        setOpenCurrencyTooltip(false);
      } else {
        setTooltipVisibility(false);
      }
    }
  }, openTooltipProps);
};
const namespace$b = 'ui-pdp-price__part';
const PriceWrapper = _ref => {
  let {
    label = '',
    amount = null,
    disabled = false,
    meta = false,
    className = '',
    centsType = 'superscript',
    num_font_size = null,
    showCurrencyText = false
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(VisuallyHidden, {}, void 0, label), /*#__PURE__*/_jsx(MoneyAmount, {
    className: cn(namespace$b, className),
    centsType: centsType,
    showCurrencyText: showCurrencyText,
    value: {
      fraction: amount === null || amount === void 0 ? void 0 : amount.fraction,
      cents: amount === null || amount === void 0 ? void 0 : amount.cents
    },
    symbol: amount === null || amount === void 0 ? void 0 : amount.symbol,
    disabled: disabled,
    meta: meta,
    size: num_font_size === 22 ? 24 : num_font_size,
    compact: true
  }));
};

/**
 * Hook personalizado para formatear precios
 * @param {number} value - El valor del precio a formatear
 * @param {Object} options - Opciones de formateo
 * @param {number} [options.num_font_size] - Tamaño de fuente para determinar el tipo de centavos
 * @param {boolean} [options.billing] - Indica si es un precio de facturación
 * @returns {Object} Objeto con las fracciones formateadas y el tipo de centavos
 */
const usePriceFormatting = function (value) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    staticProps
  } = useVppContext();
  const {
    country: {
      thousands_separator: thousandSeparator,
      decimal_separator: decimalSeparator
    },
    forceCents
  } = staticProps;
  const intFraction = useMemo(() => getFormattedIntFraction(value, thousandSeparator), [value, thousandSeparator]);
  const decimalFraction = useMemo(() => getFormattedDecimalFraction(value, forceCents), [value, forceCents]);
  const centsType = useMemo(() => (options === null || options === void 0 ? void 0 : options.num_font_size) < 16 || options !== null && options !== void 0 && options.billing ? mapDecimalSymbol[decimalSeparator === null || decimalSeparator === void 0 ? void 0 : decimalSeparator.toString()] : 'superscript', [decimalSeparator, options.num_font_size, options.billing]);
  return {
    intFraction,
    decimalFraction,
    centsType
  };
};
const RangePrice = _ref => {
  let {
    minimum_price = 0,
    maximum_price = 0,
    label_minimum = '',
    label_maximum = '',
    concat_symbol = '',
    meta = false,
    disabled = false,
    currencySymbol = '',
    showDecimals = false,
    num_font_size = null,
    centsType = 'superscript'
  } = _ref;
  const namespace = 'ui-pdp-price__part';
  const {
    intFraction: maxIntFraction,
    decimalFraction: maxDecimalFraction
  } = usePriceFormatting(maximum_price);
  const {
    intFraction: minIntfraction,
    decimalFraction: minDecimalFraction
  } = usePriceFormatting(minimum_price);
  return /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/_jsx(PriceWrapper, {
    label: label_minimum,
    amount: {
      fraction: minIntfraction,
      symbol: currencySymbol,
      symbol_text: '',
      cents: showDecimals ? minDecimalFraction : null
    },
    centsType: centsType,
    num_font_size: num_font_size,
    disabled: disabled,
    meta: meta,
    className: `${namespace}-minimum-price`
  }), /*#__PURE__*/_jsx("span", {
    className: `${namespace}-concat-symbol-${num_font_size}`,
    style: {
      fontSize: num_font_size
    }
  }, void 0, concat_symbol), /*#__PURE__*/_jsx(PriceWrapper, {
    label: label_maximum,
    amount: {
      fraction: maxIntFraction,
      symbol: currencySymbol,
      symbol_text: '',
      cents: showDecimals ? maxDecimalFraction : null
    },
    showCurrencyText: true,
    centsType: centsType,
    num_font_size: num_font_size,
    disabled: disabled,
    meta: meta,
    className: `${namespace}-maximum-price`
  }));
};
const namespace$a = 'ui-pdp-price__part';
const PricePart = _ref => {
  let {
    value,
    suffix = null,
    currencySymbol,
    className = '',
    showDecimals = true,
    strikeThrough = false,
    meta = false,
    rangePrice = null,
    num_font_size = null,
    font_family = 'REGULAR',
    billing = false
  } = _ref;
  if (!value) {
    return null;
  }
  const {
    intFraction,
    decimalFraction,
    centsType
  } = usePriceFormatting(value, {
    num_font_size,
    billing
  });
  return /*#__PURE__*/_jsx("span", {
    "data-testid": "price-part"
  }, void 0, rangePrice ? /*#__PURE__*/React.createElement(RangePrice, _extends({}, rangePrice, {
    meta: meta,
    disabled: strikeThrough,
    currencySymbol: currencySymbol,
    showDecimals: showDecimals,
    num_font_size: num_font_size,
    centsType: centsType
  })) : /*#__PURE__*/_jsx(MoneyAmount, {
    size: num_font_size === 22 ? 24 : num_font_size,
    weight: font_family.toLowerCase(),
    className: cn(namespace$a, className),
    value: {
      fraction: intFraction,
      cents: showDecimals ? decimalFraction : null
    },
    symbol: currencySymbol,
    suffix: suffix === null || suffix === void 0 ? void 0 : suffix.replace(/^\/(.*)/, '$1'),
    centsType: centsType,
    previous: strikeThrough,
    meta: meta,
    billing: billing,
    compact: true
  }));
};
var _Icon$5;
const LOYALTY_TOOLTIP_ID = 'loyalty_discount_tooltip';
const STRING_SIZES = Object.entries(ANDES.SIZES).reduce((acc, _ref) => {
  let [key, value] = _ref;
  return _objectSpread(_objectSpread({}, acc), {}, {
    [value]: key
  });
}, {});
const Discount = _ref2 => {
  let {
    className = '',
    discountLabel,
    discountLabelSecondary,
    discount_num_font_size
  } = _ref2;
  const discountSize = STRING_SIZES[discount_num_font_size];
  const size = discountLabel.font_size || (discountLabelSecondary === null || discountLabelSecondary === void 0 ? void 0 : discountLabelSecondary.font_size) || discountSize;
  const weight = (discountLabel === null || discountLabel === void 0 ? void 0 : discountLabel.font_family) || (discountLabelSecondary === null || discountLabelSecondary === void 0 ? void 0 : discountLabelSecondary.font_family) || ANDES.WEIGHTS.REGULAR;
  return /*#__PURE__*/_jsx("span", {
    className: cn({
      [`${className}__label`]: className
    }, colornames(discountLabel || discountLabelSecondary), sizenames(size), familynames(weight))
  }, void 0, discountLabel.text_icon && /*#__PURE__*/_jsx("span", {
    className: cn({
      [`${className}__icon`]: className
    })
  }, void 0, /*#__PURE__*/_jsx(Icon, {
    id: discountLabel.text_icon.id,
    className: colornames(discountLabel.text_icon)
  })), ((discountLabel === null || discountLabel === void 0 ? void 0 : discountLabel.value) === 0 || (discountLabel === null || discountLabel === void 0 ? void 0 : discountLabel.value)) && /*#__PURE__*/_jsx(MoneyAmountDiscount, {
    className: familynames((discountLabel === null || discountLabel === void 0 ? void 0 : discountLabel.value_font_family) || weight),
    compact: true,
    value: discountLabel.value,
    size: ANDES.SIZES[discountLabel === null || discountLabel === void 0 ? void 0 : discountLabel.value_font_size] || discount_num_font_size
  }), (discountLabel === null || discountLabel === void 0 ? void 0 : discountLabel.text) && /*#__PURE__*/_jsx("span", {
    className: cn({
      [`${className}__text`]: className
    })
  }, void 0, discountLabel.text), (discountLabelSecondary === null || discountLabelSecondary === void 0 ? void 0 : discountLabelSecondary.text) && /*#__PURE__*/_jsx("span", {
    className: cn({
      [`${className}__text`]: className,
      [`${className}__text__secondary`]: className
    })
  }, void 0, discountLabelSecondary.text));
};
const DiscountWithTooltip = _ref3 => {
  let {
    className = '',
    discountLabel,
    discountLabelSecondary,
    discount_num_font_size,
    setTooltipVisibility
  } = _ref3;
  return /*#__PURE__*/_jsx("span", {
    className: cn({
      [`${className}__label`]: className
    }, 'loyalty-tooltip', colornames(discountLabel), sizenames(discountLabel.font_size || 'MEDIUM')),
    onMouseEnter: () => setTooltipVisibility(true),
    onMouseLeave: () => setTooltipVisibility(false)
  }, void 0, /*#__PURE__*/React.createElement(Discount, {
    className,
    discountLabel,
    discountLabelSecondary,
    discount_num_font_size
  }), discountLabel.text, _Icon$5 || (_Icon$5 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  })));
};
const DiscountLabel = _ref4 => {
  let {
    className = '',
    discountLabel = null,
    discountLabelSecondary = null,
    tooltip = null,
    setTooltipVisibility = null,
    discount_num_font_size
  } = _ref4;
  if (!discountLabel) {
    return null;
  }
  return tooltip && tooltip.id === LOYALTY_TOOLTIP_ID ? /*#__PURE__*/_jsx(DiscountWithTooltip, {
    className: className,
    discountLabel: discountLabel,
    discountLabelSecondary: discountLabelSecondary,
    discount_num_font_size: discount_num_font_size,
    setTooltipVisibility: setTooltipVisibility
  }) : /*#__PURE__*/React.createElement(Discount, {
    className,
    discountLabel,
    discountLabelSecondary,
    discount_num_font_size
  });
};
const PriceReference = _ref => {
  let {
    className = '',
    namespace = '',
    text = '',
    color = '',
    tooltip = {
      id: '',
      subtitles: []
    },
    values = {},
    side = 'left',
    trigger = 'click'
  } = _ref;
  const [visible, setVisible] = useState(false);
  const {
    subtitles
  } = tooltip;
  const priceNamespace = `${namespace}__price-ref`;
  return /*#__PURE__*/_jsx("div", {
    className: `${priceNamespace} ${visible ? 'displace' : ''} `
  }, void 0, /*#__PURE__*/_jsx(AndesTooltip, {
    className: cn(`${priceNamespace}`, className),
    content: subtitles && subtitles.length > 0 && /*#__PURE__*/_jsx("div", {
      className: `${priceNamespace}__subtitles`
    }, void 0, subtitles.map(_ref2 => {
      let {
        text: subText,
        color: subColor
      } = _ref2;
      return /*#__PURE__*/_jsx("span", {
        className: colornames(subColor)
      }, subText, subText);
    })),
    side: side,
    open: visible,
    trigger: trigger,
    closable: true,
    onClose: () => {
      setVisible(false);
    }
  }, void 0, /*#__PURE__*/_jsx("div", {
    onClick: () => setVisible(!visible),
    "data-testid": "ui-pdp-price__price-ref"
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: cn(`${priceNamespace}-text`, colornames(color))
  }, void 0, componentEnhance.jsx(text, values)), /*#__PURE__*/_jsx(Icon, {
    id: "price_info",
    className: colornames('BLUE')
  }))));
};
const getWidgetConditions = (action, type, widgetTypes, actionTypes) => {
  var _action$type;
  const actionTypeUpper = (action === null || action === void 0 ? void 0 : action.type) && (action === null || action === void 0 || (_action$type = action.type) === null || _action$type === void 0 ? void 0 : _action$type.toUpperCase());
  const acquisitionType = type === widgetTypes.acquisition;
  const activationType = type === widgetTypes.activation;
  const splitPaymentsType = type === widgetTypes.splitPayments;
  const widgetCondition = acquisitionType || activationType || splitPaymentsType;
  const actionTypeLink = action && action.action_type === actionTypes.LINK.toUpperCase();
  const splitChevron = actionTypeLink && splitPaymentsType;
  return {
    actionTypeUpper,
    acquisitionType,
    activationType,
    splitPaymentsType,
    widgetCondition,
    actionTypeLink,
    splitChevron
  };
};
const getConditions = (action, type, widgetTypes, actionTypes) => {
  const conditions = getWidgetConditions(action, type, widgetTypes, actionTypes);
  const {
    actionTypeUpper,
    acquisitionType,
    activationType,
    splitPaymentsType,
    widgetCondition,
    actionTypeLink,
    splitChevron
  } = conditions;
  return {
    actionTypeUpper,
    acquisitionType,
    activationType,
    splitPaymentsType,
    widgetCondition,
    actionTypeLink,
    splitChevron
  };
};
var _Icon$4, _Icon2$1, _Icon3$1, _Icon4$1;
const {
  actionTypes: actionTypes$1,
  widgetTypes: widgetTypes$1
} = constants;
const namespace$9 = 'ui-vpp-payment-promotion';
const MODAL_TITLES = {
  MLA: 'Combiná dos medios de pago',
  MLB: 'Combine dois meios de pagamento',
  MLM: 'Combina dos medios de pago'
};
const PaymentPromotionDesktop = _ref => {
  var _action$label, _action$label2;
  let {
    acquisition = null,
    type = null,
    title = null,
    texts = null,
    icons = null,
    chevron = false,
    action = null,
    background_color = null,
    withDangerous = false,
    site = null
  } = _ref;
  const {
    actionTypeUpper,
    acquisitionType,
    activationType,
    splitPaymentsType,
    widgetCondition,
    actionTypeLink,
    splitChevron
  } = getConditions(action, type, widgetTypes$1, actionTypes$1);
  const ActionModalRef = React.useRef(null);
  return /*#__PURE__*/_jsx("div", {
    className: cn({
      [`${namespace$9}`]: true,
      [`acquisition`]: acquisitionType || acquisition,
      [`activation`]: activationType
    })
  }, void 0, title && /*#__PURE__*/_jsx(StyledLabel, {
    className: cn(`${namespace$9}__title`),
    color: title.color,
    font_family: title.font_family,
    font_size: title.font_size,
    as: "p",
    text: title.text
  }), /*#__PURE__*/_jsx("div", {
    className: cn(`${namespace$9}__container`, backgroundColor(background_color), {
      'split-payments': splitPaymentsType
    })
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace$9}__container-icon`
  }, void 0, icons && /*#__PURE__*/_jsx(PaymentIcon, {
    icons: icons,
    iconClassName: `${namespace$9}__icon`,
    lazy: true
  })), /*#__PURE__*/_jsx("div", {
    className: cn(`${namespace$9}__container-text`)
  }, void 0, texts && texts.map(text => /*#__PURE__*/_jsx(StyledLabel, {
    className: cn(`${namespace$9}__text ${text !== null && text !== void 0 && text.classname ? text.classname : ''}`),
    color: text.color,
    font_family: text.font_family,
    font_size: text.font_size,
    as: "p",
    text: /*#__PURE__*/React.createElement(Icon, text.text_icon),
    withDangerous: withDangerous
  }, void 0, componentEnhance.jsx(text.text, text.values)))), splitChevron && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("button", {
    type: "button",
    className: `${namespace$9}__action_button_chevron`,
    onClick: () => {
      ActionModalRef.current.openModal();
      trackEvent(action.track);
    },
    title: action.accessibility_text,
    "data-testid": "payment-promotion-button-chevron"
  }, void 0, _Icon$4 || (_Icon$4 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  }))), action.target && /*#__PURE__*/_jsx(ActionModal, {
    modalClassName: "ui-pdp-iframe-modal split-payments-modal",
    deviceType: "desktop",
    modalTitle: MODAL_TITLES[site],
    url: action.target,
    closeModalLabel: "Fechar",
    customRef: ActionModalRef
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    title: MODAL_TITLES[site],
    src: action.target,
    scrolling: "no",
    onMessage: onIframeModalResize('vpp:iframe-modal:resize', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header', 'width', 'desktop')
  }))), actionTypeLink && !splitPaymentsType && /*#__PURE__*/_jsx("a", {
    href: action.target,
    target: action.html_target || '_self',
    className: `${namespace$9}__action_chevron`,
    onClick: () => {
      trackEvent(action.track);
    },
    title: action.accessibility_text,
    "data-testid": "payment-promotion-anchor-chevron"
  }, void 0, _Icon2$1 || (_Icon2$1 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  }))), widgetCondition && action && action.action_type === actionTypes$1.BUTTON.toUpperCase() && /*#__PURE__*/_jsx("div", {
    className: `${namespace$9}__container-button`
  }, void 0, /*#__PURE__*/_jsx(Button, {
    href: action.target,
    target: action.html_target || '_self',
    size: "medium",
    onClick: () => {
      trackEvent(action.track);
    }
  }, void 0, (_action$label = action.label) === null || _action$label === void 0 ? void 0 : _action$label.text)), action && actionTypeUpper === actionTypes$1.LINK.toUpperCase() && /*#__PURE__*/_jsx(Row, {}, void 0, /*#__PURE__*/React.createElement(MediaAction, _extends({
    className: cn(`${namespace$9}__action`),
    htmlTarget: action.html_target
  }, action)), /*#__PURE__*/_jsx("a", {
    href: action.target,
    target: action.html_target || '_self',
    className: cn(`${namespace$9}__action__icon`)
  }, void 0, _Icon3$1 || (_Icon3$1 = /*#__PURE__*/_jsx(Icon, {
    id: "right_arrow"
  })))), action && action.type === actionTypes$1.BUTTON && /*#__PURE__*/_jsx("div", {
    className: `${namespace$9}__container-button`
  }, void 0, /*#__PURE__*/_jsx(Button, {
    href: action.target,
    target: action.html_target || '_self',
    size: "medium",
    onClick: () => {
      trackEvent(action.track);
    }
  }, void 0, (_action$label2 = action.label) === null || _action$label2 === void 0 ? void 0 : _action$label2.text)), chevron && (!(action !== null && action !== void 0 && action.type) || actionTypeUpper !== actionTypes$1.LINK.toUpperCase()) && /*#__PURE__*/_jsx("a", {
    href: action === null || action === void 0 ? void 0 : action.target,
    target: (action === null || action === void 0 ? void 0 : action.html_target) || '_self',
    className: `${namespace$9}__action`,
    onClick: trackEvent(action === null || action === void 0 ? void 0 : action.track),
    title: action === null || action === void 0 ? void 0 : action.accessibility_text,
    "data-testid": "payment-promotion-anchor-chevron"
  }, void 0, _Icon4$1 || (_Icon4$1 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  })))));
};
var _Icon$3, _Icon2, _Icon3, _Icon4;
const {
  actionTypes,
  widgetTypes
} = constants;
const namespace$8 = 'ui-vpp-payment-promotion';
const PaymentPromotionMobile = _ref => {
  var _action$label, _action$label2;
  let {
    acquisition = null,
    type = null,
    title = null,
    texts = null,
    icons = null,
    chevron = false,
    action = null,
    background_color = null,
    withDangerous = false,
    showPaymentsSplitModal = () => {}
  } = _ref;
  const {
    actionTypeUpper,
    acquisitionType,
    activationType,
    splitPaymentsType,
    widgetCondition,
    actionTypeLink,
    splitChevron
  } = getConditions(action, type, widgetTypes, actionTypes);
  return /*#__PURE__*/_jsx("div", {
    className: cn({
      [`${namespace$8}`]: true,
      [`acquisition`]: acquisitionType || acquisition,
      [`activation`]: activationType
    })
  }, void 0, title && /*#__PURE__*/_jsx(StyledLabel, {
    className: cn(`${namespace$8}__title`),
    color: title.color,
    font_family: title.font_family,
    font_size: title.font_size,
    as: "p",
    text: title.text
  }), /*#__PURE__*/_jsx("div", {
    className: cn(`${namespace$8}__container`, backgroundColor(background_color), {
      'split-payments': splitPaymentsType
    })
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace$8}__container-icon`
  }, void 0, icons && /*#__PURE__*/_jsx(PaymentIcon, {
    icons: icons,
    iconClassName: `${namespace$8}__icon`,
    lazy: true
  })), /*#__PURE__*/_jsx("div", {
    className: cn(`${namespace$8}__container-text`)
  }, void 0, texts && texts.map(text => /*#__PURE__*/_jsx(StyledLabel, {
    className: cn(`${namespace$8}__text ${text !== null && text !== void 0 && text.classname ? text.classname : ''}`),
    color: text.color,
    font_family: text.font_family,
    font_size: text.font_size,
    as: "p",
    text: /*#__PURE__*/React.createElement(Icon, text.text_icon),
    withDangerous: withDangerous
  }, void 0, componentEnhance.jsx(text.text, text.values)))), splitChevron && /*#__PURE__*/_jsx("button", {
    type: "button",
    className: `${namespace$8}__action_button_chevron`,
    onClick: () => {
      showPaymentsSplitModal({
        target: action.target,
        deviceType: 'mobile'
      });
      trackEvent(action.track);
    },
    title: action.accessibility_text,
    "data-testid": "payment-promotion-button-chevron"
  }, void 0, _Icon$3 || (_Icon$3 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  }))), actionTypeLink && !splitPaymentsType && /*#__PURE__*/_jsx("a", {
    href: action.target,
    target: action.html_target || '_self',
    className: `${namespace$8}__action_chevron`,
    onClick: () => {
      trackEvent(action.track);
    },
    title: action.accessibility_text,
    "data-testid": "payment-promotion-anchor-chevron"
  }, void 0, _Icon2 || (_Icon2 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  }))), widgetCondition && action && action.action_type === actionTypes.BUTTON.toUpperCase() && /*#__PURE__*/_jsx("div", {
    className: `${namespace$8}__container-button`
  }, void 0, /*#__PURE__*/_jsx(Button, {
    href: action.target,
    target: action.html_target || '_self',
    size: "medium",
    onClick: () => {
      trackEvent(action.track);
    }
  }, void 0, (_action$label = action.label) === null || _action$label === void 0 ? void 0 : _action$label.text)), action && actionTypeUpper === actionTypes.LINK.toUpperCase() && /*#__PURE__*/_jsx(Row, {}, void 0, /*#__PURE__*/React.createElement(MediaAction, _extends({
    className: cn(`${namespace$8}__action`),
    htmlTarget: action.html_target
  }, action)), /*#__PURE__*/_jsx("a", {
    href: action.target,
    target: action.html_target || '_self',
    className: cn(`${namespace$8}__action__icon`)
  }, void 0, _Icon3 || (_Icon3 = /*#__PURE__*/_jsx(Icon, {
    id: "right_arrow"
  })))), action && action.type === actionTypes.BUTTON && /*#__PURE__*/_jsx("div", {
    className: `${namespace$8}__container-button`
  }, void 0, /*#__PURE__*/_jsx(Button, {
    href: action.target,
    target: action.html_target || '_self',
    size: "medium",
    onClick: () => {
      trackEvent(action.track);
    }
  }, void 0, (_action$label2 = action.label) === null || _action$label2 === void 0 ? void 0 : _action$label2.text)), chevron && (!(action !== null && action !== void 0 && action.type) || actionTypeUpper !== actionTypes.LINK.toUpperCase()) && /*#__PURE__*/_jsx("a", {
    href: action === null || action === void 0 ? void 0 : action.target,
    target: (action === null || action === void 0 ? void 0 : action.html_target) || '_self',
    className: `${namespace$8}__action`,
    onClick: trackEvent(action === null || action === void 0 ? void 0 : action.track),
    title: action === null || action === void 0 ? void 0 : action.accessibility_text,
    "data-testid": "payment-promotion-anchor-chevron"
  }, void 0, _Icon4 || (_Icon4 = /*#__PURE__*/_jsx(Icon, {
    id: "chevron"
  })))));
};
const promotionToProps = props => _objectSpread(_objectSpread({}, props), {}, {
  icons: [props.icon]
});
const PaymentPromotion = props => {
  const context = useVppContext();
  const {
    staticProps
  } = context;
  const {
    deviceType,
    siteId
  } = staticProps;
  const PaymentPromotionComponent = deviceType === 'mobile' ? PaymentPromotionMobile : PaymentPromotionDesktop;
  return /*#__PURE__*/React.createElement(PaymentPromotionComponent, _extends({}, props, {
    site: siteId
  }));
};
const namespace$7 = 'ui-pdp-price__tags';
const Tags = _ref => {
  let {
    tags
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: namespace$7
  }, void 0, tags.map(row => /*#__PURE__*/_jsx("div", {
    className: `${namespace$7}__wrapper-tags`
  }, void 0, row.tag_action ? /*#__PURE__*/_jsx(ActionModal, {
    modalTitle: row.description_action.modal_title,
    componentAsLabel: /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(StyledLabel, {
      className: `${namespace$7}--wrapper-tags--click`,
      as: "span",
      color: row.tag_action.label.color,
      bg_color: row.tag_action.label.bg_color,
      font_family: row.tag_action.label.font_family,
      font_size: row.tag_action.label.font_size,
      text: componentEnhance.jsx(row.tag_action.label.text, row.tag_action.label.values)
    }, row.tag_action.label)),
    modalClassName: "ui-pdp-iframe-modal",
    url: row.description_action.target,
    closeModalLabel: row.tag_action.close_modal_label
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    title: row.description_action.modal_title,
    scrolling: "no",
    src: row.description_action.target,
    onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header')
  })) : /*#__PURE__*/React.createElement(Label, _extends({}, row.tag, {
    text: componentEnhance.jsx(row.tag.text, row.tag.values),
    className: `${row.tag.text_icon ? `${namespace$7}--${row.tag.text_icon.id} ui-pdp-promotions-pill__label--tag` : 'ui-pdp-promotions-pill__label--tag'}`
  })), row.info && /*#__PURE__*/React.createElement(Label, _extends({
    className: "ui-pdp-promotions-pill__label--info"
  }, row.info)), row.description_action && /*#__PURE__*/_jsx(ActionModal, {
    label: row.description_action.label,
    modalClassName: "ui-pdp-iframe-modal",
    modalTitle: row.description_action.modal_title,
    url: row.description_action.target,
    closeModalLabel: row.description_action.close_modal_label
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    title: row.description_action.modal_title,
    scrolling: "no",
    src: row.description_action.target,
    onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header')
  })))));
};
const namespace$6 = 'ui-pdp-price__payments-link';
const PaymentMethodsLinkDesktop = _ref => {
  let {
    label,
    target,
    className = '',
    modal_title,
    track,
    close_modal_label
  } = _ref;
  const handleClick = () => {
    if (track) {
      trackEvent(track);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: cn(namespace$6, className),
    onClick: handleClick,
    role: "presentation"
  }, void 0, /*#__PURE__*/_jsx(ActionModal, {
    componentAsLabel: label.text,
    modalClassName: "ui-pdp-iframe-modal",
    modalTitle: modal_title,
    url: `${target}?controlled=true`,
    closeModalLabel: close_modal_label
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    title: label.text,
    src: `${target}?controlled=true`,
    scrolling: "no",
    onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header')
  })));
};
const namespace$5 = 'ui-pdp-price__payments-link';
const PaymentMethodsLinkMobile = _ref => {
  let {
    label,
    target,
    className = '',
    track,
    modal_title = null,
    close_modal_label
  } = _ref;
  const handleClick = () => {
    if (track) {
      trackEvent(track);
    }
  };
  const isNewVersionModal = target && stringIncludes(target, 'new_version=true');
  if (isNewVersionModal) {
    return /*#__PURE__*/_jsx(ActionModal, {
      deviceType: "mobile",
      componentAsLabel: label.text,
      modalTitle: modal_title,
      modalClassName: "ui-pdp-iframe-modal",
      className: `${namespace$5}__action`,
      track: track,
      url: target,
      closeModalLabel: close_modal_label
    }, void 0, /*#__PURE__*/_jsx(Iframe, {
      title: label ? label.text : null,
      src: target,
      onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header'),
      scrolling: "no",
      width: "100%"
    }));
  }
  return /*#__PURE__*/_jsx("div", {
    className: cn(namespace$5, className)
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: target,
    className: `${namespace$5}__link`,
    onClick: handleClick
  }, target, label.text));
};
const namespace$4 = 'ui-vpp-carousel-tags';
const CarouselDiscounts = /*#__PURE__*/React.memo(_ref => {
  let {
    tags = null,
    className = '',
    id,
    close_modal_label,
    ariaLabel = ''
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: namespace$4
  }, void 0, /*#__PURE__*/_jsx(CarouselFree, {
    className: cn(namespace$4, `${namespace$4}__carousel`, className),
    srLabel: ariaLabel,
    pagination: false,
    arrowsVisible: false,
    arrows: false,
    autoplay: false,
    spacing: 0,
    lazyload: false
  }, void 0, tags.map(tag => /*#__PURE__*/_jsx(CarouselFreeSlide, {
    className: `${namespace$4}__slide`
  }, id, (tag === null || tag === void 0 ? void 0 : tag.tag) && /*#__PURE__*/_jsx(ActionModal, {
    modalClassName: "ui-pdp-iframe-modal",
    modalTitle: tag.modal_title,
    url: tag.target,
    componentAsLabel: /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: "ui-vpp-discounts__tags",
      key: tag.tag.text
    }, tag.tag, {
      text: componentEnhance.jsx(tag.tag.text)
    })),
    closeModalLabel: close_modal_label
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    src: tag.target,
    scrolling: "no",
    onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header')
  }))))));
});
CarouselDiscounts.displayName = 'CarouselDiscounts';
CarouselDiscounts.propTypes = {
  ariaLabel: string,
  className: string,
  close_modal_label: string.isRequired,
  id: string.isRequired,
  tags: arrayOf(shape({
    label: shape({
      text: string.isRequired,
      color: string
    }).isRequired
  }))
};
const namespace$3 = 'ui-vpp-discounts';
const renderIframe = target => /*#__PURE__*/_jsx(Iframe, {
  src: target,
  scrolling: "no",
  onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header')
});
const DiscountsTags = _ref => {
  let {
    tags = null,
    className = '',
    id,
    max_pills_to_show = 2,
    plus_button,
    close_modal_label
  } = _ref;
  /* istanbul ignore next */
  const actionModalRef = React.useRef(null);
  const openActionModal = () => {
    var _actionModalRef$curre;
    /* istanbul ignore next */
    (_actionModalRef$curre = actionModalRef.current) === null || _actionModalRef$curre === void 0 || _actionModalRef$curre.openModal();
  };
  const renderTag = tag => /*#__PURE__*/_jsx(TagElement, {
    className: `${namespace$3}__tag`
  }, id, (tag === null || tag === void 0 ? void 0 : tag.tag) && /*#__PURE__*/_jsx(ActionModal, {
    modalClassName: "ui-pdp-iframe-modal",
    modalTitle: tag.modal_title,
    url: tag.target,
    componentAsLabel: /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: "ui-vpp-discounts__tags",
      key: tag.tag.text
    }, tag.tag, {
      text: componentEnhance.jsx(tag.tag.text)
    })),
    closeModalLabel: close_modal_label
  }, void 0, renderIframe(tag.target)));
  const renderModalPlusButton = () => /*#__PURE__*/_jsx(ActionModal, {
    modalClassName: "ui-pdp-iframe-modal",
    modalTitle: plus_button.modal_title,
    url: plus_button.target,
    closeModalLabel: close_modal_label,
    customRef: actionModalRef
  }, void 0, renderIframe(plus_button.target));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(TagLimited, {
    limit: max_pills_to_show,
    onClickPlusButton: openActionModal,
    className: className
  }, void 0, tags.map(renderTag)), renderModalPlusButton());
};
const namespace$2 = 'ui-pdp-price__volume-tags';
const DiscountsVolumeTags = _ref => {
  let {
    tags = null
  } = _ref;
  const shouldRedirect = (event, _ref2) => {
    let {
      target,
      track
    } = _ref2;
    event.preventDefault();
    trackEvent(track);
    window.location.href = target;
  };
  return /*#__PURE__*/_jsx("div", {
    className: namespace$2
  }, void 0, tags.map(_ref3 => {
    let {
      label,
      subtitle,
      action,
      modifier
    } = _ref3;
    return /*#__PURE__*/_jsx(Card, {
      className: cn(`${namespace$2}--container`, {
        [`${namespace$2}--container--clickeable`]: action,
        [`${namespace$2}--${modifier}`]: modifier
      }),
      onClick: e => (action === null || action === void 0 ? void 0 : action.target) && shouldRedirect(e, action)
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace$2}--pill-container`
    }, void 0, /*#__PURE__*/_jsx(TagElement, {}, void 0, /*#__PURE__*/React.createElement(StyledLabel, _extends({}, label, {
      as: "span",
      className: `${namespace$2}--pill`,
      accessibilityText: label.accessibility_text,
      text: componentEnhance.jsx(label.text)
    }))), subtitle && /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: `${namespace$2}--subtitle`
    }, subtitle))), action && /*#__PURE__*/_jsx("span", {
      className: `${namespace$2}--action-container`
    }, void 0, action.label && /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: `${namespace$2}--label`
    }, action.label)), action.highlight && /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: `${namespace$2}--highlight`
    }, action.highlight))));
  }));
};
var _Icon$2;
const BUY_LOYALTY_TOOLTIP_ID$2 = 'buy_loyalty_level_tooltip';
const PriceExtrasDesktop = _ref => {
  let {
    namespace = 'ui-pdp-price',
    cards_credits_component = null,
    price_tags = null,
    discounts_tags = null,
    volume_discount_tags = null,
    action = null,
    plus_button = null,
    tooltip = null,
    closeModalLabel = null,
    showTooltip = false
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, cards_credits_component && /*#__PURE__*/React.createElement(PaymentPromotion, _extends({}, cards_credits_component, {
    acquisition: true
  })), price_tags && price_tags.length > 0 && /*#__PURE__*/_jsx(Tags, {
    tags: price_tags
  }), discounts_tags && !!discounts_tags.length && /*#__PURE__*/_jsx("div", {
    className: `${namespace}__discounts-tags`
  }, void 0, /*#__PURE__*/_jsx(DiscountsTags, {
    tags: discounts_tags,
    plus_button: plus_button
  })), action && /*#__PURE__*/React.createElement(PaymentMethodsLinkDesktop, action), volume_discount_tags && /*#__PURE__*/_jsx(DiscountsVolumeTags, {
    tags: volume_discount_tags
  }), tooltip && tooltip.id === BUY_LOYALTY_TOOLTIP_ID$2 && !showTooltip && /*#__PURE__*/_jsx("div", {
    className: `${namespace}__loyalty-purchase-description`
  }, void 0, _Icon$2 || (_Icon$2 = /*#__PURE__*/_jsx(Icon, {
    id: "loyalty_points",
    color: "GREEN"
  })), /*#__PURE__*/_jsx("span", {}, void 0, tooltip.title.text, " "), /*#__PURE__*/_jsx(ActionModal, {
    modalClassName: `${namespace}__buy-loyalty-modal`,
    url: tooltip.action.target,
    label: tooltip.action.label,
    closeModalLabel: closeModalLabel
  }, void 0, /*#__PURE__*/_jsx(Iframe, {
    title: tooltip.action.label.text,
    src: tooltip.action.target,
    scrolling: "no",
    height: 525
  }))));
};
var _Icon$1;
const BUY_LOYALTY_TOOLTIP_ID$1 = 'buy_loyalty_level_tooltip';
const PriceExtrasMobile = _ref => {
  let {
    namespace = 'ui-pdp-price',
    cards_credits_component = null,
    price_tags = null,
    discounts_tags = null,
    volume_discount_tags = null,
    action = null,
    tooltip = null,
    showTooltip = false
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, cards_credits_component && /*#__PURE__*/React.createElement(PaymentPromotion, _extends({}, cards_credits_component, {
    chevron: true
  })), price_tags && price_tags.length > 0 && /*#__PURE__*/_jsx(Tags, {
    tags: price_tags
  }), discounts_tags && discounts_tags.length > 0 && /*#__PURE__*/_jsx("div", {
    className: `${namespace}__discounts-tags`
  }, void 0, /*#__PURE__*/_jsx(CarouselDiscounts, {
    tags: discounts_tags
  })), action && /*#__PURE__*/React.createElement(PaymentMethodsLinkMobile, action), volume_discount_tags && /*#__PURE__*/_jsx(DiscountsVolumeTags, {
    tags: volume_discount_tags
  }), tooltip && tooltip.id === BUY_LOYALTY_TOOLTIP_ID$1 && !showTooltip && /*#__PURE__*/_jsx("div", {
    className: `${namespace}__loyalty-purchase-description`
  }, void 0, _Icon$1 || (_Icon$1 = /*#__PURE__*/_jsx(Icon, {
    id: "loyalty_points",
    color: "GREEN"
  })), /*#__PURE__*/_jsx("span", {}, void 0, tooltip.title.text, " "), /*#__PURE__*/React.createElement(StyledLabel, _extends({
    className: "view-more__link",
    as: "a",
    href: tooltip.action.target
  }, tooltip.action.label))));
};
var _Icon;
const BUY_LOYALTY_TOOLTIP_ID = 'buy_loyalty_level_tooltip';
const CURRENCY_TOOLTIP_ID$3 = 'currency_tooltip';
const TooltipContentMobile = _ref => {
  let {
    id,
    title,
    subtitles,
    icon = null,
    action = null,
    namespace = 'ui-pdp-price'
  } = _ref;
  if (id === BUY_LOYALTY_TOOLTIP_ID || id === CURRENCY_TOOLTIP_ID$3) {
    return /*#__PURE__*/_jsx("div", {
      className: `${namespace}__tooltip-${id}`
    }, void 0, icon && /*#__PURE__*/React.createElement(Icon, icon), /*#__PURE__*/_jsx("div", {
      className: `${id}__content`
    }, void 0, /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: `${namespace}__tooltip-${id}__title`,
      as: "span"
    }, title)), subtitles.map(subtitle => /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: cn(`${namespace}__subtitle`, `${namespace}__tooltip-${id}__subtitle`),
      key: subtitle.text,
      as: "p"
    }, subtitle))), action && /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: `${namespace}__tooltip-${id}__action view-more__link`,
      as: "a",
      href: action.target
    }, action.label)), action && !action.hide_chevron && (_Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      id: "chevron"
    })))));
  }
  return null;
};
const CURRENCY_TOOLTIP_ID$2 = 'currency_tooltip';
const TooltipCardMobile = _ref => {
  let {
    tooltip,
    setTooltipVisibility,
    showTooltip,
    toggleCurrencyTooltipVisibility,
    namespace = 'ui-pdp-price'
  } = _ref;
  const {
    id,
    storable
  } = tooltip;
  const updateCloseStatus = useViewCounter({
    id,
    visible: showTooltip,
    storable,
    cookieName: 'tooltips-configuration'
  });
  const handleCloseTooltip = () => {
    if (storable) {
      if (tooltip && tooltip.id === CURRENCY_TOOLTIP_ID$2) {
        localStorage.setItem(CURRENCY_TOOLTIP_ID$2, Math.floor(Date.now() / 1000));
        toggleCurrencyTooltipVisibility(false);
      }
      updateCloseStatus();
    }
    setTooltipVisibility(false);
  };
  return /*#__PURE__*/_jsx(Card$1, {
    className: cn(`${namespace}__tooltip-card `, {
      [backgroundColor(tooltip)]: tooltip
    }, {
      'ui-pdp-card-tooltip__card ui-pdp-card-tooltip__card--arrow-top-left': tooltip.id === CURRENCY_TOOLTIP_ID$2
    })
  }, void 0, /*#__PURE__*/_jsx("span", {
    "data-testid": "action-close-button",
    role: "button",
    tabIndex: "0",
    className: "andes-tooltip-button-close",
    onClick: handleCloseTooltip
  }), /*#__PURE__*/React.createElement(TooltipContentMobile, tooltip));
};
const CURRENCY_TOOLTIP_ID$1 = 'currency_tooltip';
const usePriceTooltip = tooltip => {
  const [showTooltip, setTooltipVisibility] = useState(tooltip && !tooltip.closed);
  const [showCurrencyTooltip, toggleCurrencyTooltipVisibility] = useTooltipWithFrequencyStatus(CURRENCY_TOOLTIP_ID$1, -1);
  const isCurrencyTooltip = (tooltip === null || tooltip === void 0 ? void 0 : tooltip.id) === CURRENCY_TOOLTIP_ID$1;
  const showCurrencyPriceTooltip = isCurrencyTooltip ? showCurrencyTooltip : showTooltip;
  const handleShowTooltip = useCallback((e, showCurrencyTooltipOnClick, toggleCurrencyTooltipVisibilityOnClick) => {
    e.preventDefault();
    if (!showCurrencyTooltipOnClick) {
      toggleCurrencyTooltipVisibilityOnClick(true);
    }
  }, []);
  return {
    showTooltip,
    isCurrencyTooltip,
    showCurrencyTooltip,
    setTooltipVisibility,
    toggleCurrencyTooltipVisibility,
    showCurrencyPriceTooltip,
    handleShowTooltip
  };
};
const namespace$1 = 'ui-pdp-price';
const PriceMobile = _ref => {
  let {
    bold = false,
    className = '',
    size = null,
    modifier = null,
    meta = false,
    upperLabel = null,
    currencySymbol,
    originalValue = null,
    value,
    label = null,
    discountLabel = null,
    discountLabelSecondary = null,
    bulkSalesUnit = null,
    discountLabelSubtitle = null,
    shouldShowPriceExtra = true,
    subtitles = null,
    tooltip = null,
    price_tags = null,
    discounts_tags = null,
    volume_discount_tags = null,
    priceReference = null,
    action = null,
    rangePrice = null,
    billing = false,
    num_font_size = PriceFontSize.MOBILE_DEFAULT,
    original_value_num_font_size = PriceFontSize.ORIGINAL_DEFAULT,
    discount_num_font_size = DiscountFontSize.DEFAULT,
    cards_credits_component = null,
    credits_consumer = null,
    widget = null,
    showPaymentsSplitModal = () => {},
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    var _bulkSalesUnit$text;
    /* eslint-disable react-hooks/rules-of-hooks */
    const {
      showTooltip,
      isCurrencyTooltip,
      showCurrencyTooltip,
      setTooltipVisibility,
      toggleCurrencyTooltipVisibility,
      showCurrencyPriceTooltip,
      handleShowTooltip
    } = usePriceTooltip(tooltip);
    if (!value && !label) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
      className: cn(namespace$1, className, {
        [`${namespace$1}--size-${size}`]: size,
        [`${namespace$1}--${modifier}`]: modifier
      })
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace$1}__main-container`
    }, void 0, upperLabel && /*#__PURE__*/_jsx("div", {
      className: cn(`${namespace$1}__upper`, colornames(upperLabel.color))
    }, void 0, upperLabel.text), originalValue && /*#__PURE__*/_jsx(PricePart, {
      className: `${namespace$1}__original-value`,
      value: originalValue,
      rangePrice: rangePrice,
      currencySymbol: currencySymbol,
      billing: billing,
      num_font_size: original_value_num_font_size,
      strikeThrough: true
    }), priceReference && /*#__PURE__*/React.createElement(PriceReference, _extends({
      namespace: namespace$1
    }, priceReference, {
      side: "bottom",
      trigger: "click"
    })), /*#__PURE__*/_jsx("div", {
      className: cn(`${namespace$1}__second-line`, {
        [`${namespace$1}__second-line--bold`]: bold,
        [`${namespace$1}__second-line--double`]: !!discountLabelSecondary
      })
    }, void 0, label && /*#__PURE__*/_jsx("div", {
      className: colornames(label.color)
    }, void 0, componentEnhance.jsx(label.text, label.values)), value && /*#__PURE__*/_jsx(PricePart, {
      className: bulkSalesUnit !== null && bulkSalesUnit !== void 0 && bulkSalesUnit.hasUnits ? `${namespace$1}__bulk-part` : '',
      rangePrice: rangePrice,
      value: value,
      currencySymbol: currencySymbol,
      suffix: (_bulkSalesUnit$text = bulkSalesUnit === null || bulkSalesUnit === void 0 ? void 0 : bulkSalesUnit.text) !== null && _bulkSalesUnit$text !== void 0 ? _bulkSalesUnit$text : '',
      meta: meta,
      billing: billing,
      num_font_size: num_font_size
    }), discountLabelSubtitle && /*#__PURE__*/_jsx("span", {
      className: `${namespace$1}__label-discount`
    }, void 0, discountLabelSubtitle.text), /*#__PURE__*/React.createElement(DiscountLabel, {
      className: `${namespace$1}__second-line`,
      discountLabel,
      discountLabelSecondary,
      discount_num_font_size
    }), isCurrencyTooltip && /*#__PURE__*/_jsx("span", {
      "data-testid": "info-icon",
      className: `${namespace$1}__info-icon`,
      onClick: e => handleShowTooltip(e, showCurrencyTooltip, toggleCurrencyTooltipVisibility),
      role: "button",
      tabIndex: "-1"
    }, void 0, /*#__PURE__*/_jsx(Icon, {
      id: "price_info",
      className: colornames('BLUE')
    }))), subtitles && subtitles.length > 0 && /*#__PURE__*/_jsx("div", {
      className: `${namespace$1}__subtitles`,
      role: "group"
    }, void 0, subtitles.map(subtitle => /*#__PURE__*/_jsx("span", {
      className: cn(`${namespace$1}__subtitle`, colornames(subtitle.color), familynames(subtitle.font_family), sizenames(subtitle.font_size), margins(subtitle.margin))
    }, void 0, componentEnhance.jsx(subtitle.text, subtitle.values, null, PriceFontSize.PRODUCT_SUBTITLE[subtitle.font_size])))), credits_consumer && /*#__PURE__*/React.createElement(PaymentPromotion, _extends({}, credits_consumer, {
      showPaymentsSplitModal: showPaymentsSplitModal
    })), widget && /*#__PURE__*/React.createElement(PaymentPromotion, _extends({}, widget, {
      showPaymentsSplitModal: showPaymentsSplitModal
    }))), shouldShowPriceExtra && /*#__PURE__*/_jsx(PriceExtrasMobile, {
      cards_credits_component: cards_credits_component,
      price_tags: price_tags,
      discounts_tags: discounts_tags,
      volume_discount_tags: volume_discount_tags,
      action: action,
      tooltip: tooltip,
      showTooltip: showTooltip
    })), tooltip && showCurrencyPriceTooltip && /*#__PURE__*/React.createElement(TooltipCardMobile, {
      tooltip,
      setTooltipVisibility,
      showTooltip,
      toggleCurrencyTooltipVisibility
    }));
    /* eslint-enable react-hooks/rules-of-hooks */
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const MappedPriceMobile = props => /*#__PURE__*/React.createElement(PriceMobile, _extends({
  size: "large"
}, jsonToProps(props)));
const _excluded = ["text", "values", "color", "font_family", "font_size", "num_font_size", "className"];
const Subtitles = _ref => {
  let {
      text = null,
      values = null,
      color = 'SMALL',
      font_family = 'REGULAR',
      font_size = 'MEDIUM',
      num_font_size = null,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    className: className,
    key: text,
    as: "p",
    color: color,
    font_family: font_family,
    font_size: font_size,
    text: componentEnhance.jsx(text, values, null, num_font_size)
  }, rest));
};
const CURRENCY_TOOLTIP_ID = 'currency_tooltip';
const withTooltip = WrappedComponent => {
  const TooltipHOC = props => {
    const {
      namespace,
      tooltip = null,
      showTooltip = false,
      setTooltipVisibility = () => {}
    } = props;
    if (!tooltip) {
      return /*#__PURE__*/React.createElement(WrappedComponent, props);
    }
    const [openCurrencyTooltip, setOpenCurrencyTooltip] = useTooltipWithFrequencyStatus(CURRENCY_TOOLTIP_ID, -1);
    const isCurrencyTooltip = (tooltip === null || tooltip === void 0 ? void 0 : tooltip.id) === CURRENCY_TOOLTIP_ID;
    const useHoverTrigger = !openCurrencyTooltip;
    const tooltipProps = getTooltipProps({
      tooltip,
      namespace,
      showTooltip,
      setTooltipVisibility,
      openCurrencyTooltip,
      setOpenCurrencyTooltip,
      useHoverTrigger,
      isCurrencyTooltip
    });
    return /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      isCurrencyTooltip: isCurrencyTooltip
    })));
  };
  return TooltipHOC;
};
const PriceCore = _ref => {
  var _bulkSalesUnit$text;
  let {
    namespace,
    bold = false,
    meta = false,
    currencySymbol = null,
    value = null,
    label = null,
    discountLabel = null,
    discountLabelSecondary = null,
    bulkSalesUnit = null,
    discountLabelSubtitle = null,
    tooltip = null,
    rangePrice = null,
    num_font_size = null,
    discount_num_font_size = null,
    isCurrencyTooltip = false,
    setTooltipVisibility = () => {}
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(`${namespace}__second-line`, {
      [`${namespace}__second-line--bold`]: bold,
      [`${namespace}__second-line--double`]: !!discountLabelSecondary
    })
  }, void 0, label && /*#__PURE__*/_jsx("div", {
    className: colornames(label.color)
  }, void 0, componentEnhance.jsx(label.text, label.values)), value && /*#__PURE__*/_jsx(PricePart, {
    className: bulkSalesUnit !== null && bulkSalesUnit !== void 0 && bulkSalesUnit.hasUnits ? `${namespace}__bulk-part` : '',
    rangePrice: rangePrice,
    value: value,
    currencySymbol: currencySymbol,
    suffix: (_bulkSalesUnit$text = bulkSalesUnit === null || bulkSalesUnit === void 0 ? void 0 : bulkSalesUnit.text) !== null && _bulkSalesUnit$text !== void 0 ? _bulkSalesUnit$text : '',
    meta: meta,
    num_font_size: num_font_size
  }), discountLabelSubtitle && /*#__PURE__*/_jsx("span", {
    className: `${namespace}__label-discount`
  }, void 0, discountLabelSubtitle.text), /*#__PURE__*/React.createElement(DiscountLabel, {
    className: `${namespace}__second-line`,
    discountLabel,
    discountLabelSecondary,
    tooltip,
    setTooltipVisibility,
    discount_num_font_size
  }), isCurrencyTooltip && /*#__PURE__*/_jsx(Icon, {
    id: "price_info",
    className: colornames('BLUE')
  }));
};
const PriceWithTooltip = withTooltip(PriceCore);
const namespace = 'ui-pdp-price';
const PriceDesktop = props => {
  const {
    className = '',
    size = null,
    modifier = null,
    upperLabel = null,
    currencySymbol,
    originalValue = null,
    bulkSalesUnit = null,
    subtitles = null,
    tooltip = null,
    price_tags = null,
    discounts_tags = null,
    volume_discount_tags = null,
    plus_button = null,
    cards_credits_component = null,
    credits_consumer = null,
    widget = null,
    action = null,
    priceReference = null,
    rangePrice = null,
    closeModalLabel,
    original_value_num_font_size = PriceFontSize.ORIGINAL_DEFAULT,
    billing = false,
    shouldShowPriceExtra = true,
    runCatchErrorBoundary = () => {},
    bold = false,
    discountLabel = null,
    meta = false,
    discountLabelSubtitle = null,
    label = null,
    discount_num_font_size = DiscountFontSize.DEFAULT,
    discountLabelSecondary = null,
    value = null,
    num_font_size = PriceFontSize.DEFAULT
  } = props;
  try {
    const [showTooltip, setTooltipVisibility] = useState(tooltip && !tooltip.closed);
    return /*#__PURE__*/_jsx("div", {
      className: cn(namespace, className, {
        [`${namespace}--size-${size}`]: size,
        [`${namespace}--${modifier}`]: modifier
      })
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__main-container`
    }, void 0, upperLabel && /*#__PURE__*/_jsx("div", {
      className: cn(`${namespace}__upper mt-8`, colornames(upperLabel.color))
    }, void 0, upperLabel.text), originalValue && /*#__PURE__*/_jsx(PricePart, {
      className: `${namespace}__original-value`,
      value: originalValue,
      currencySymbol: currencySymbol,
      rangePrice: rangePrice,
      num_font_size: original_value_num_font_size,
      strikeThrough: true,
      billing: billing
    }), priceReference && /*#__PURE__*/React.createElement(PriceReference, _extends({
      namespace: namespace
    }, priceReference, {
      side: "left",
      trigger: "hover"
    })), /*#__PURE__*/_jsx(PriceWithTooltip, {
      namespace: namespace,
      bold: bold,
      meta: meta,
      currencySymbol: currencySymbol,
      value: value,
      label: label,
      discountLabel: discountLabel,
      discountLabelSecondary: discountLabelSecondary,
      bulkSalesUnit: bulkSalesUnit,
      discountLabelSubtitle: discountLabelSubtitle,
      tooltip: tooltip,
      rangePrice: rangePrice,
      num_font_size: num_font_size,
      discount_num_font_size: discount_num_font_size,
      showTooltip: showTooltip,
      setTooltipVisibility: setTooltipVisibility
    }), subtitles && subtitles.length > 0 && /*#__PURE__*/_jsx("div", {
      className: bulkSalesUnit !== null && bulkSalesUnit !== void 0 && bulkSalesUnit.hasUnits ? `${namespace}__bulk-subtitles` : `${namespace}__subtitles`,
      role: "group"
    }, void 0, subtitles.map(subtitle => /*#__PURE__*/React.createElement(Subtitles, _extends({
      key: subtitle.text,
      num_font_size: PriceFontSize.PRODUCT_SUBTITLE[subtitle.font_size]
    }, subtitle)))), (widget || credits_consumer) && /*#__PURE__*/React.createElement(PaymentPromotion, widget || credits_consumer)), shouldShowPriceExtra && /*#__PURE__*/_jsx(PriceExtrasDesktop, {
      cards_credits_component: cards_credits_component,
      price_tags: price_tags,
      discounts_tags: discounts_tags,
      volume_discount_tags: volume_discount_tags,
      action: action,
      plus_button: plus_button,
      tooltip: tooltip,
      closeModalLabel: closeModalLabel,
      showTooltip: showTooltip
    }));
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const MappedPriceDesktop = props => /*#__PURE__*/React.createElement(PriceDesktop, _extends({
  meta: true,
  className: "mt-16",
  size: "large"
}, jsonToProps(props)));
const PriceInline = _ref => {
  let {
    value,
    currencySymbol,
    originalValue = null,
    color = null,
    num_font_size,
    font_family
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PricePart, {
    value,
    currencySymbol,
    num_font_size,
    font_family,
    className: colornames(color)
  }), originalValue && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(PricePart, {
    className: 'ui-pdp-price__part__previous',
    value: originalValue,
    currencySymbol,
    strikeThrough: true,
    num_font_size,
    font_family
  })));
};
const Price = props => {
  const context = useVppContext();
  const {
    staticProps
  } = context;
  const {
    deviceType
  } = staticProps;
  const PriceComponent = deviceType === 'mobile' ? PriceMobile : PriceDesktop;
  return /*#__PURE__*/React.createElement(PriceComponent, props);
};
export { CarouselDiscounts, DiscountLabel, DiscountsTags, MappedPriceDesktop, MappedPriceMobile, PaymentMethodsLinkDesktop, PaymentMethodsLinkMobile, PaymentPromotion, Price, PriceDesktop, PriceExtrasDesktop, PriceExtrasMobile, PriceInline, PriceMobile, PricePart, PriceReference, PriceWrapper, RangePrice, Subtitles, Tags, TooltipCardMobile, TooltipContentMobile, getFormattedDecimalFraction, getFormattedIntFraction, getTooltipContent, getTooltipProps, jsonToProps, mapDecimalSymbol, promotionToProps };
